import { SpeakerPresentation } from '@/api/dtos';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Grid, Typography, styled } from '@mui/material';
import { FileUpload, ITableArrayFieldColumn, Input, InputOnlyField, TableArrayField, Text, ToggleButtonGroup } from '@ngt/forms';
import { FC } from 'react';
import { ErrorFields } from '../errors/ErrorFields';
import { StyledAccordianSummary, StyledAccordion, StyledAccordionDetails } from './SpeakerForm';

const StyledTypography = styled(Typography)(({theme}) => ({
    paddingBottom: theme.spacing(2),
}))

interface SpeakerGuideSectionProps {
}

const presentationColumns: Array<ITableArrayFieldColumn<SpeakerPresentation>> = [
    {
        TableHeadCellProps: {
                sx: {
                    width: '20%'
                }
            },
        propertyPath: 'presentationTitle',
        headerLabel: 'Presentation Title',
        content: (
            <Input
                component={Text}
                variant='standard'
                
            />
        )
    },
    {
        TableHeadCellProps: {
                sx: {
                    width: '80%'
                }
            },
        propertyPath: 'overviewInformation',
        headerLabel: 'Overview Information',
        content: (
            <Input
                component={Text}
                variant='standard'
            />
        )
    },
    {
        TableHeadCellProps: {
            sx: {
                width: '80%'
            }
        },
        propertyPath: 'presentation',
        headerLabel: 'Presentation',
        content: (
            <Input
                component={FileUpload}
            />
        )
    }
];

const SpeakerGuideSection: FC<SpeakerGuideSectionProps> = ({
}) => {

    return (
        <>
            <StyledAccordion elevation={4}>
                <StyledAccordianSummary 
                    expandIcon={<FontAwesomeIcon fixedWidth icon={faChevronDown} color='white' />}

                >
                    <Typography variant="h3" color="white"><b>Speaker Guide</b></Typography>   
                </StyledAccordianSummary>
                <StyledAccordionDetails>


                    <StyledTypography variant='body1'>
                        To assist with your planning and preparation for the 2026 BCT ASM, we are pleased to provide the following information.
                    </StyledTypography>



                    < a href={`/download/asm-template`} target="_blank" rel="noopener noreferrer">
                            2026 ASM Slide Deck Template
                    </a>
                                                            
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            marginTop: '20px',
                            marginBottom: '20px'
                        }}
                    >
                        <Grid
                            container
                            spacing={4}
                        >

                            <Grid
                                item
                                {...{
                                    xs: 12,
                                    sm: 8,
                                    md: 8
                                }}
                            >
                                <Typography>Your slides will be made available through the Breast Cancer Trials members-only section of the website. Do you agree to this?</Typography>
                            </Grid>
                            <Grid
                                item
                                {...{
                                    xs: 12,
                                    sm: 4,
                                    md: 4
                                }}
                            >
                                <InputOnlyField
                                    propertyPath="agreeSharePresentation"
                                    component={ToggleButtonGroup}
                                    sx={{margin:"normal"}}
                                />
                            </Grid>

                        </Grid>
                    </Box>
                    
                    {
                        <>
                            <StyledTypography variant='body1'>
                                <i>
                                    Please upload your completed presentation slides here. BCT will access your presentation from this folder during the conference. 
                                    BCT cannot accept presentations via memory sticks during the ASM.
                                    Please make sure your presentation is uploaded by Monday 27th July.
                                </i>
                            </StyledTypography>
                            {
                               (
                                    <>
                                        <TableArrayField
                                            propertyPath='speakerPresentations'
                                            columns={presentationColumns}
                                            entityName='Presentation'
                                            
                                        />
                                    </>
                                )
                            }
                            <StyledTypography 
                                sx={{paddingTop: '20px'}}
                                variant='h2'
                            >
                                Arrival At The Conference
                            </StyledTypography>
                            <StyledTypography variant='body1'>
                                The BCT conference will be held at the <a href='https://www.idem.events/r/anz-breast-cancer-trials'>Sofitel</a>, Brisbane Central, in the Ballroom le Grand. Please come to the registration desk (which will be open from 8:00am on Wednesday 29 July) to pick up your name badge, and staff will direct you to the speakers preparation space. An AV technician will be available to assist you with your presentation on the day. Speakers are discouraged from using their own laptop to present unless it is a Mac Book.
                            </StyledTypography>
                            <StyledTypography variant='body1'>
                                The equipment available in session rooms includes:
                            </StyledTypography>
                            <ul>
                                <li>Projector Screen</li>
                                <li>Projector</li>
                                <li>Lectern with microphone</li>
                                <li>Computer with sound</li>
                                <li>Wireless mouse/remote clicker</li>
                            </ul>
                            <StyledTypography variant='body1'>
                                All currently received <a href="https://bct2026.org/?page_id=3180">speaker</a> and <a href="https://bct2026.org/?page_id=2487">session</a> information is available on our <a href="https://bct2026.org/">conference website</a>.
                            </StyledTypography>

                            <StyledTypography 
                                sx={{paddingTop: '20px'}}
                                variant='h2'
                            >
                                Before Your Session
                            </StyledTypography>
                            <StyledTypography variant='body1'>
                                Please arrive in the session room 10 minutes prior to the start of the session to meet the Session Chairs. The conference must keep to the given schedule, and the Session Chair will advise you at 5 and 1-minute intervals before your presentation time expires.
                            </StyledTypography>
                            <StyledTypography variant='body1'>
                                Delegates from the audience will be provided a microphone during question time. Session chairs will oversee question time.
                            </StyledTypography>
                            
                        </>
                    }   
                </StyledAccordionDetails>
            </StyledAccordion>
            <ErrorFields
                errorFields={[
                    "presentationTitle",
                    "overviewInformation",
                    "presentation",
                    "speakerPresentations",
                    "agreeSharePresentation",
                ]}
            />
        </>

    )
}

export default SpeakerGuideSection;
